module.exports = __webpack_public_path__ + "static/img/noData.cbfb089f.png";